import { Action } from '@ngrx/store';

import { PersistAction } from '../../state/container-persist-edit.actions';

export enum QueueActionTypes {
  INIT_QUEUE = '[Container Edit Queue] Init queue with list etag',
  UPDATE_QUEUE_ETAG = '[Container Edit Queue] Update queue etag',
  LOCK_QUEUE_FOR_SHIFT = '[Container Edit Queue] Lock queue for shift',
  UNLOCK_QUEUE_AND_SHIFT = '[Container Edit Queue] Unlock, shift and update etag',
}

export interface ETagPayload {
  etag: string;
}

export interface UnlockQueueAndShift {
  persistAction: PersistAction;
  etag: string;
}

export class InitQueueAction implements Action {
  readonly type = QueueActionTypes.INIT_QUEUE;

  constructor(public payload: ETagPayload) {}
}

export class UpdateQueueETagAction implements Action {
  readonly type = QueueActionTypes.UPDATE_QUEUE_ETAG;

  constructor(public payload: ETagPayload) {}
}

export class LockQueueForShiftAction implements Action {
  readonly type = QueueActionTypes.LOCK_QUEUE_FOR_SHIFT;
}

export class UnlockQueueAndShiftAction implements Action {
  readonly type = QueueActionTypes.UNLOCK_QUEUE_AND_SHIFT;

  constructor(public payload: UnlockQueueAndShift) {}
}

export type QueueActions =
  | InitQueueAction
  | LockQueueForShiftAction
  | UnlockQueueAndShiftAction
  | UpdateQueueETagAction;
